import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { useCompany } from '../context/CompanyContext';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import './Dashboard.css';

const LEADS = [
  {name:'Anand Kumar',src:'Meta Ads',badge:'Hot',cls:'db-b-gold'},
  {name:'Priya Sharma',src:'Website',badge:'New',cls:'db-b-green'},
  {name:'Rajesh Nair',src:'Referral',badge:'Warm',cls:'db-b-blue'},
  {name:'Meera Pillai',src:'Meta Ads',badge:'New',cls:'db-b-green'},
];
const TEAM=[{name:'Lakshmi',pct:90},{name:'Arjun',pct:85},{name:'Meera',pct:72},{name:'Kiran',pct:60}];
const AI_INSIGHTS=[
  {text:<><strong>Anand Kumar</strong> hasn't been followed up in 3 days.</>},
  {text:<>Revenue on track to hit <strong>₹3L</strong> if 4 warm leads close.</>},
  {text:<><strong>2 employees</strong> haven't marked attendance today.</>},
  {text:<>Next billing in <strong>30 days</strong> — ₹7,499.</>},
];

/* KPI Detail modals */
const KPI_DETAILS = {
  revenue: {
    title:'Revenue this month', color:'#F5A623',
    rows:[
      {label:'Invoices paid',val:'₹1,75,000',note:'2 invoices'},
      {label:'Pending',val:'₹2,40,000',note:'4 invoices'},
      {label:'Overdue',val:'₹35,000',note:'1 invoice'},
      {label:'Target',val:'₹3,00,000',note:'86% achieved'},
    ],
    note:'View full breakdown in Finance →',
    path:'/finance',
  },
  leads: {
    title:'Active leads', color:'#22C55E',
    rows:[
      {label:'New',val:'12',note:'6 today'},
      {label:'Contacted',val:'9',note:''},
      {label:'Warm',val:'10',note:''},
      {label:'Hot',val:'7',note:'needs follow-up'},
      {label:'Closed',val:'6',note:'this month'},
      {label:'Lost',val:'4',note:''},
    ],
    note:'View all leads →',
    path:'/leads',
  },
  tasks: {
    title:'Tasks done', color:'#3B82F6',
    rows:[
      {label:'Completed',val:'47',note:''},
      {label:'Overdue',val:'2',note:'action needed'},
      {label:'In progress',val:'8',note:''},
      {label:'Not started',val:'3',note:''},
    ],
    note:'View all projects →',
    path:'/projects',
  },
  team: {
    title:'Team present', color:'#8B5CF6',
    rows:[
      {label:'Present today',val:'9',note:''},
      {label:'On leave',val:'3',note:'approved'},
      {label:'Absent',val:'0',note:''},
      {label:'Total members',val:'12',note:''},
    ],
    note:'View team →',
    path:'/team',
  },
};

function KPIModal({ data, theme, onClose, navigate }) {
  return (
    <div className="db-kpi-overlay" onClick={onClose}>
      <div className="db-kpi-modal" data-theme={theme} onClick={e=>e.stopPropagation()}>
        <div className="db-kpi-hd">
          <div className="db-kpi-title" style={{color:data.color}}>{data.title}</div>
          <div className="db-kpi-close" onClick={onClose}>✕</div>
        </div>
        <div className="db-kpi-rows">
          {data.rows.map(r=>(
            <div key={r.label} className="db-kpi-row">
              <span className="db-kpi-row-lbl">{r.label}</span>
              <div className="db-kpi-row-right">
                <span className="db-kpi-row-val">{r.val}</span>
                {r.note && <span className="db-kpi-row-note">{r.note}</span>}
              </div>
            </div>
          ))}
        </div>
        <div className="db-kpi-link" onClick={()=>{navigate(data.path);onClose();}}>{data.note}</div>
      </div>
    </div>
  );
}

export default function Dashboard() {
  const {theme}  = useTheme();
  const {isComplete} = useCompany();
  const navigate = useNavigate();
  const today = new Date().toLocaleDateString('en-IN',{weekday:'long',day:'numeric',month:'long',year:'numeric'});
  const [kpiModal, setKpiModal] = useState(null);

  const STATS = [
    {key:'revenue',lbl:'Revenue this month',val:'₹2.4L',chg:'↑ 18% vs last month',cls:'db-up',valColor:'#F5A623'},
    {key:'leads',  lbl:'Active leads',      val:'48',   chg:'↑ 6 new today',      cls:'db-up'},
    {key:'tasks',  lbl:'Tasks done',        val:'94%',  chg:'2 overdue',           cls:'db-warn'},
    {key:'team',   lbl:'Team present',      val:'9/12', chg:'3 on leave',          cls:'db-dn'},
  ];

  return (
    <div className="db-wrap" data-theme={theme}>
      <Sidebar/>
      <div className="db-main">
        <Topbar title={<>Good morning, <span>Dhanush</span> 👋</>}/>
        {!isComplete && (
          <div className="db-banner" onClick={()=>navigate('/onboarding')}>
            <div className="db-banner-left">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/></svg>
              <div><div className="db-banner-title">Complete your company profile</div><div className="db-banner-sub">Add your company details to unlock invoice templates, auto-fill, and more.</div></div>
            </div>
            <div className="db-banner-btn">Set up now →</div>
          </div>
        )}
        <div className="db-content">
          <div className="db-today">
            <div><div className="db-today-sub">{today}</div><div className="db-today-title">3 follow-ups due today</div></div>
            <div className="db-chips">
              <div className="db-chip db-chip-gold">3 leads</div>
              <div className="db-chip db-chip-green">2 done</div>
              <div className="db-chip db-chip-red">1 overdue</div>
            </div>
          </div>
          <div className="db-stats">
            {STATS.map(s=>(
              <div key={s.key} className="db-stat db-stat-clickable" onClick={()=>setKpiModal(s.key)}>
                <div className="db-stat-lbl">{s.lbl}</div>
                <div className="db-stat-val" style={s.valColor?{color:s.valColor}:{}}>{s.val}</div>
                <div className={`db-stat-chg ${s.cls}`}>{s.chg}</div>
                <div className="db-stat-hint">Click to expand ↗</div>
              </div>
            ))}
          </div>
          <div className="db-mid">
            <div className="db-panel">
              <div className="db-panel-hd"><span className="db-panel-title">Recent leads</span><span className="db-panel-link" onClick={()=>navigate('/leads')}>View all →</span></div>
              {LEADS.map(l=>(
                <div key={l.name} className="db-lead-row">
                  <div><div className="db-lead-name">{l.name}</div><div className="db-lead-src">{l.src}</div></div>
                  <span className={`db-badge ${l.cls}`}>{l.badge}</span>
                </div>
              ))}
            </div>
            <div className="db-ai">
              <div className="db-ai-hd"><div className="db-ai-dot"/><span className="db-ai-title">Ryzen AI</span></div>
              {AI_INSIGHTS.map((a,i)=><div key={i} className="db-ai-item">{a.text}</div>)}
            </div>
          </div>
          <div className="db-bot">
            <div className="db-panel">
              <div className="db-panel-hd"><span className="db-panel-title">Team performance</span></div>
              {TEAM.map(t=>(
                <div key={t.name} className="db-bar-row">
                  <span className="db-bar-lbl">{t.name}</span>
                  <div className="db-bar-track"><div className="db-bar-fill" style={{width:t.pct+'%'}}/></div>
                  <span className="db-bar-pct">{t.pct}%</span>
                </div>
              ))}
            </div>
            <div className="db-panel">
              <div className="db-panel-hd"><span className="db-panel-title">Billing</span></div>
              {[{lbl:'Status',val:'✓ Active',color:'#22C55E'},{lbl:'Next payment',val:'26 June 2026'},{lbl:'Amount',val:'₹7,499 / month'}].map(r=>(
                <div key={r.lbl} className="db-bill-row"><div className="db-bill-lbl">{r.lbl}</div><div className="db-bill-val" style={r.color?{color:r.color}:{}}>{r.val}</div></div>
              ))}
              <div className="db-manage-btn">Manage →</div>
            </div>
          </div>
        </div>
      </div>
      {kpiModal && <KPIModal data={KPI_DETAILS[kpiModal]} theme={theme} onClose={()=>setKpiModal(null)} navigate={navigate}/>}
    </div>
  );
}
